import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import treatment from './view/treatment.vue'
import treatmentList from './view/treatmentList.vue'

Vue.use(VueRouter)
let routers = {
    mode: 'hash',
    routes: [
        {
            path: '/',
            component: App,
            children: [
                {
                    path: '',
                    redirect: '/home/133',
                    name: 'home'
                },
                {
                    path: '/home/:marketId',
                    component: treatment,
                    name: 'home'
                },
                {
                    path: '/treatmentList/:marketId',
                    component: treatmentList,
                    name: 'treatmentList'
                }
            ]
        },
    ],
    strict: false
}

const router = new VueRouter(routers)
const title = {
    home: {title: '首页', limit: 'noPath'},
    treatmentList: {title: '兑换信息', limit: 'noPath'},
}

router.beforeEach(function (to, from, next) {
    let activitySource = to.query.activitySource || ''
    let activeId = +to.query.activeId || 0
    
    localStorage.setItem('firstEnterTime', new Date().getTime())
    localStorage.setItem('activitySource', activitySource)
    localStorage.setItem('activeId', activeId || '')
    let getTicketTime = localStorage.getItem('getTicketTime') // 上次成功获取优惠券的时间
    // 领取时间过去7天或者领取时间不存在重置所有本地缓存
    if (!getTicketTime || (getTicketTime && (Date.now() - getTicketTime) > (1000 * 60 * 60 * 24 * 7))) {
        if (Prius && Prius.isInsideApp) {
            window.localStorage.clear()
        }
    }
    let path = to.path
    let pastPage = site.getLocal('current')
    //添加页面标题
    document.title = title[to.name].title
    //设置上一页缓存
    localStorage.setItem('referrers', window.location.href)
    //判断页面是否需要登陆
    if (title[to.name] && title[to.name].limit == 'login' && !site.isLogin()) {
        if (Prius && Prius.isInsideApp) {
            Prius.login()
        } else {
            router.go('#/' + title[to.name].limit)
        }
    }
    ////判断页面是否纪录历史
    if (title[to.name] && title[to.name].limit == 'noPath') {
        next()
        return
    }
    if (pastPage != undefined && (path != pastPage)) {
        site.getLocal('referrer', pastPage)
    }
    site.getLocal('current', path)
    next()
})


export default router



// WEBPACK FOOTER //
// ./src/routers.js